export default __webpack_public_path__ + "static/media/SwiftPackage.0135da37.png";